import React from 'react';
import {
  FieldErrors,
  FieldValues,
  RegisterOptions,
  UseFormRegister,
} from 'react-hook-form';
import { FormGroup, Input, Label } from 'reactstrap';
import './LoATemplate.css';
import { Device } from '../../domain/devices';
import { useTranslation } from 'react-i18next';

interface Props {
  type: string;
  paths: string[];
  register: UseFormRegister<FieldValues>;
  devicesList?: Device[];
  errors: FieldErrors;
}

export const LoATemplate = (props: Props) => {
  const { t } = useTranslation();
  const { errors, register } = props;

  return (
    <FormGroup>
      {React.Children.toArray(
        props.paths.map((path) => {
          let fieldName = path;
          let registerOptions: RegisterOptions = {
            required: t('form.fillfield'),
          };
          if (path === 'email') {
            fieldName = 'emailPath';
            registerOptions = {
              required: t('form.fillfield'),
              pattern: {
                value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                message: t('form.provideValidEmail'),
              },
            };
          }
          if (path === 'personalNumber') {
            registerOptions = {
              required: t('form.fillfield'),
              pattern: {
                value: /^[a-zA-Z0-9]+$/,
                message: t('form.provideValidNumber'),
              },
            };
          }

          const { ref, ...rest } = register(fieldName, registerOptions);

          return (
            <>
              {path !== 'deviceId' && (
                <Input
                  key={path}
                  className="pathField"
                  id={props.type}
                  placeholder={path}
                  type="text"
                  innerRef={ref}
                  {...rest}
                />
              )}

              {path === 'deviceId' &&
                props.devicesList &&
                props.devicesList.length > 0 && (
                  <>
                    <Label>{t('details.selectDevice')}</Label>
                    <Input
                      key={path}
                      className="pathField"
                      id={props.type}
                      type="select"
                      innerRef={ref}
                      {...rest}
                    >
                      {props.devicesList.map((device) => {
                        return (
                          <option key={device.deviceId} value={device.deviceId}>
                            {device.deviceName}
                          </option>
                        );
                      })}
                    </Input>
                  </>
                )}

              {errors[fieldName] && (
                <span className="error-span">{errors[fieldName]?.message}</span>
              )}
            </>
          );
        }),
      )}
    </FormGroup>
  );
};
